import React from "react";
import SearchReceipt from "./SearchReceipt";

export default function SearchReaceiptCon(props) {
  const {
    openSearchMdl,  handCloseDw,
    onRowClick, URL ,type,tname,AutoOptions, transition ,isInternal,AutoOptionsB} = props;

  return (
    <SearchReceipt
      {...{
        openSearchMdl,  handCloseDw,
        onRowClick, URL ,type,tname,AutoOptions,transition,isInternal,AutoOptionsB
          }}
    />
  );
}
